import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const Translate = ({string, defaultString, translations, currentLocale, locales}) => {
    return <span lang={currentLocale}>{translations[string] ? (translations[string][locales[currentLocale]] ? translations[string][locales[currentLocale]] : defaultString ) : defaultString}</span>
}

const mapStateToProps = state => ({
    translations: state.Translations.translations,
    currentLocale: state.Translations.currentLocale,
    locales: state.Translations.locales
})

export default connect(mapStateToProps)(Translate);


// WEBPACK FOOTER //
// ./src/modules/Translations/components/Translate/index.js